import { createFileRoute } from '@tanstack/react-router';

import { queryClient } from '~app/query-client';

import { getAllStudentsWithSearchOptions } from '~entities/student/api/get-all-students-with-search';

import { StudentListPage } from '~features/students/index';

export const Route = createFileRoute('/_auth/_layout/students/')({
  component: StudentListPage,
  loader: async ({ preload }) => {
    // Preload initial student data with default parameters
    // This will be used as a placeholder until the component loads with actual URL params
    const defaultParams = {
      page: 1,
      limit: 10,
      name: '',
      familyName: undefined,
    };

    // Use the same queryOptions that the component will use
    const options = getAllStudentsWithSearchOptions(defaultParams);

    // Preload the data using the queryClient
    await queryClient.ensureQueryData(options);

    return {
      maxAge: preload ? 5 * 60 * 1000 : 0, // Preloaded data stays valid for 5 minutes
    };
  },
});
